// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export class UserDelegationKeyCredential {
}
//# sourceMappingURL=UserDelegationKeyCredential.browser.js.map